import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslateScopes } from '@cloud-twin-v2/cloud-twin-shared/core/translate-scopes';
import { MasterOperatorSingleSettings } from '../master-operator-single/master-operator-single-settings';
import { MasterOperatorConnectItemsSettings } from '../models/master-operator-connect-settings';
import { MasterOperatorType } from '../models/master-operator-type';

const COMPONENT_SELECTOR = 'tc-master-operator-connect';

@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './master-operator-connect.component.html',
    styleUrls: ['./master-operator-connect.component.scss'],
    standalone: false
})
export class MasterOperatorConnectComponent implements OnInit {
  private _settings: MasterOperatorSingleSettings;
  get settings(): MasterOperatorSingleSettings {
    return this._settings;
  }
  @Input() set settings(value: MasterOperatorSingleSettings) {
    this._settings = value;
    if (this.settings) {
      this.buildMainLabelKey();

      if (this.settings.connect) {
        this.configured.emit(this.settings);
      }
    }
  }

  private _isValid: boolean;
  public get isValid(): boolean {
    return this._isValid;
  }
  public set isValid(value: boolean) {
    this._isValid = value;
    this.validChanged.next(value);
  }

  @Input() associatedMaster: string;
  @Input() masterInstanceIds: string[];
  @Input() showTitle = true;
  @Output() configured = new EventEmitter<MasterOperatorSingleSettings>();
  @Output() validChanged = new EventEmitter<boolean>();

  readonly T_SCOPE = `${TranslateScopes.MasterOperator}.${COMPONENT_SELECTOR}`;
  mainLabelKey: string;
  masterBeforeOperatorLabelKey = `${this.T_SCOPE}.sub-label.master-before-operator`;
  showMasterBeforeOperatorLabel = false;
  // This component is only shown for operators now.
  masterOperatorType = MasterOperatorType.Operator;
  control = new UntypedFormControl();

  constructor() {}

  ngOnInit(): void {
    this.control.statusChanges.subscribe((_) => {
      this.isValid = this.control.valid;
      if (this.control.valid) {
        const connectSettings: MasterOperatorConnectItemsSettings = this.control.value;
        connectSettings.singleId = this.settings.singleId;
        const singleSettings = new MasterOperatorSingleSettings({
          ...this.settings,
          connect: connectSettings,
        });
        this.configured.emit(singleSettings);
      }
    });

    if (this.settings.connect) {
      this.control.setValue(this.settings.connect);
    }
  }

  private buildMainLabelKey(): void {
    const key =
      this.settings.type === MasterOperatorType.Master
        ? 'main-label.master'
        : 'main-label.operator';
    this.mainLabelKey = `${this.T_SCOPE}.${key}`;
  }
}
